import { render, staticRenderFns } from "./opto.vue?vue&type=template&id=6c2da873&scoped=true&"
import script from "./opto.vue?vue&type=script&lang=js&"
export * from "./opto.vue?vue&type=script&lang=js&"
import style0 from "./opto.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./opto.vue?vue&type=style&index=1&id=6c2da873&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2da873",
  null
  
)

export default component.exports